import type { AnyType, PaginatedResponse } from "types/DataTypes";

import { api } from "./api.ts";

type ServiceAssignee = {
  id: number;
  user: number;
  user_full_name: string;
  user_role: string[];
  service: number;
};

export const serviceAssigneeAPI = api.injectEndpoints({
  endpoints: (build) => ({
    createServiceAssignee: build.mutation<
      ServiceAssignee,
      { data: Partial<ServiceAssignee> }
    >({
      query: ({ data }) => {
        return {
          url: "api/v1/serviceassignees/",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: [
        "ServiceAssignee",
        "FileValidation",
        "TeamBandWidth",
        "Tasks",
      ],
    }),
    getServiceAssignees: build.query<
      PaginatedResponse<ServiceAssignee>,
      { serviceId: string }
    >({
      query: ({ serviceId }) => ({
        url: `api/v1/serviceassignees/?service_id=${serviceId}`,
        method: "GET",
      }),
      providesTags: ["ServiceAssignee", "FileValidation"],
    }),
    deleteServiceId: build.mutation<AnyType, { id: string }>({
      query: ({ id }) => ({
        url: `api/v1/serviceassignees/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ServiceAssignee", "TeamBandWidth"],
    }),
    updateServiceAssignee: build.mutation<
      AnyType,
      {
        assigneeId: string | number;
        userId: string | number;
      }
    >({
      query: ({ assigneeId, userId }) => ({
        url: `api/v1/serviceassignees/${assigneeId}/`,
        method: "PATCH",
        body: { user: userId },
      }),
      invalidatesTags: ["ServiceAssignee", "FileValidation", "TeamBandWidth"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetServiceAssigneesQuery,
  useCreateServiceAssigneeMutation,
  useDeleteServiceIdMutation,
  useUpdateServiceAssigneeMutation,
} = serviceAssigneeAPI;
